<template>
	<v-container>
		<v-row >
			<v-col cols="12">
				<v-subheader>Общие</v-subheader>
				<v-radio-group
					v-model="prefs.lan"
					@change="gotChanges = true"
					label="Язык по умолчанию для P&L отчетов">
					<v-radio
						v-for="l in lans"
						:key="l.value"
						:label="l.text"
						:value="l.value"
					></v-radio>
				</v-radio-group>
			</v-col>

			<v-col cols="12">
				<v-subheader>Уведомления на электронную почту</v-subheader>
				<v-radio-group
					v-model="prefs.prInboxNotifications"
					@change="gotChanges = true"
					label="О новых заявках на расходы, требующих согласования">
					<v-radio
						v-for="opt in prInboxNotificationOptions"
						:key="opt.value"
						:label="opt.text"
						:value="opt.value"
					></v-radio>
				</v-radio-group>
			</v-col>
			<v-col cols="12">
				<v-switch
					label="О согласовании моих заявок на расходы"
					v-model="prefs.prAuthorNotificationsApprove"
					@change="gotChanges = true"
					true-value="ALL"
					false-value="NONE"
				></v-switch>
			</v-col>
			<v-col cols="12">
				<v-switch
					label="Об оплате ордеров по моим заявкам на расходы"
					v-model="prefs.prAuthorNotificationsPaid"
					@change="gotChanges = true"
					true-value="ALL"
					false-value="NONE"
				></v-switch>
			</v-col>
			<v-col cols="12">
				<v-switch
					label="Об отклонении моих заявок на расходы"
					v-model="prefs.prAuthorNotificationsReject"
					@change="gotChanges = true"
					true-value="ALL"
					false-value="NONE"
				></v-switch>
			</v-col>
			<v-col cols="12">
				<v-switch
					label="О сбросе согласований по моим заявкам на расходы"
					v-model="prefs.prAuthorNotificationsDrop"
					@change="gotChanges = true"
					true-value="ALL"
					false-value="NONE"
				></v-switch>
			</v-col>
			<v-col cols="12">
				<v-switch
					label="Об отзыве согласования по моим заявкам на расходы"
					v-model="prefs.prAuthorNotificationsWithdraw"
					@change="gotChanges = true"
					true-value="ALL"
					false-value="NONE"
				></v-switch>
			</v-col>
			<v-col cols="12">
				<v-switch
					label="О новых комментариях к заявкам на расходы"
					v-model="prefs.prCommentNotifications"
					@change="gotChanges = true"
					true-value="ALL"
					false-value="NONE"
				></v-switch>
			</v-col>
			<v-col cols="12">
				<v-switch
					label="Об ордерах на оплату, требующих согласования"
					v-model="prefs.poInboxNotifications"
					@change="gotChanges = true"
					true-value="ALL"
					false-value="NONE"
				></v-switch>
			</v-col>
			<v-col cols="12">
				<v-switch
					label="О новых комментариях к ордерам на оплату"
					v-model="prefs.poCommentNotifications"
					@change="gotChanges = true"
					true-value="ALL"
					false-value="NONE"
				></v-switch>
			</v-col>
			<v-col>
				<v-btn
					@click="save"
					color="primary"
					:disabled="!gotChanges"
				>
					Сохранить
				</v-btn>
			</v-col>
			<v-col cols="12">
				<v-subheader>Смена пароля</v-subheader>
			</v-col>
		</v-row>
		<v-form ref="f" v-model="valid">
			<v-row>
				<v-col cols="6">
					<v-text-field 	v-model="oldPassword"
									prepend-icon="lock"
									:rules="[rules.required]"
									label="Старый пароль"
									autocomplete="off"
									type="password">
					</v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="6">
					<v-text-field 	v-model="newPassword"
									prepend-icon="lock"
									:rules="[rules.required, rules.min]"
									label="Новый пароль"
									counter
									autocomplete="off"
									type="password">
					</v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="6">
					<v-text-field 	v-model="newPasswordConfirm"
									prepend-icon="lock"
									:rules="[
										rules.required,
										v => v == newPassword || 'Пароли не совпадают'
									]"
									label="Повтор нового пароля"
									counter
									autocomplete="off"
									type="password">
					</v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-btn
						@click="changePassword"
						:disabled="!valid"
						color="primary"
					>
						Изменить пароль
					</v-btn>
				</v-col>
			</v-row>
		</v-form>
	</v-container>
</template>

<script>
import {api} from '../../lib/api'
export default {
	data: () => ({
		lans: [
			{
				value: 'en',
				text: 'Английский'
			},
			{
				value: 'ru',
				text: 'Русский'
			}
		],
		prInboxNotificationOptions: [
			{
				value: 'ALL',
				text: 'О каждой заявке'
			},
			{
				value: 'DAILY',
				text: 'Раз в день'
			},
			{
				value: 'NONE',
				text: 'Не присылать'
			},
		],
		prefs: {
			lan: '',
			prInboxNotifications: '',
			prAuthorNotificationsApprove: '',
			prAuthorNotificationsPaid: '',
			prAuthorNotificationsReject: '',
			prAuthorNotificationsDrop: '',
			prAuthorNotificationsWithdraw: '',
			prCommentNotifications: '',
			poInboxNotifications: '',
			poCommentNotifications: '',
		},
		gotChanges: false,
		oldPassword: '',
		newPassword: '',
		newPasswordConfirm: '',
		showPassword: false,
		showPasswordConfirm: false,
		rules: {
			required: value => !!value || 'Обязательно',
			min: v => v.length >= 8 || 'Минимум 8 символов'
        },
		valid: false

	}),
	computed: {

	},
	created() {
		this.apiFirstCall()
	},
	methods: {
		apiFirstCall() {
			api.post('pref/get_user_prefs')
			.then(response => {
				this.prefs = response.data.prefs
				// this.lan = response.data.prefs.lan
				// this.prInboxNotifications = response.data.prefs.prInboxNotifications
				// this.prAuthorNotificationsApprove = response.data.prefs.prAuthorNotificationsApprove
				// this.prAuthorNotificationsPaid = response.data.prefs.prAuthorNotificationsPaid
				// this.prAuthorNotificationsReject = response.data.prefs.prAuthorNotificationsReject
				// this.prAuthorNotificationsDrop = response.data.prefs.prAuthorNotificationsDrop
				// this.prAuthorNotificationsWithdraw = response.data.prefs.prAuthorNotificationsWithdraw
				// this.prCommentNotifications = response.data.prefs.prCommentNotifications
			})
		},
		save() {
			if (this.$store.getters.isDemo) return

			api.post('pref/set_user_prefs', {
				prefs: this.prefs
			})
			.then(response => {
				this.$store.dispatch('setPreferences', this.prefs)
				this.gotChanges = false
			})
		},
		changePassword() {
			if (this.$store.getters.isDemo) return

			this.$store.dispatch('dialogLoadingStart')
			api.post('pref/pass_change', {
				oldPassword: this.oldPassword,
				newPassword: this.newPassword
			})
			.then(response => {
				this.oldPassword = ''
				this.newPassword = ''
				this.newPasswordConfirm = ''
				this.$refs.f.resetValidation()
				this.$store.dispatch('dialogLoadingStop')
				this.$store.dispatch('dialogNotify', {
					title: 'Готово',
					message: 'Пароль успешно изменен. Вам придется заново авторизоваться.'
				})
				.then(response => {
					this.$store.dispatch('dialogNotifyHide')
					this.$store.dispatch('destroyToken')
					this.$router.push('/login')
				})
			})
		}
	},
}
</script>
